import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const GYNECOLOGICAL_ABDOMEN_FORM_INITIAL_VALUES = {
  sections: {
    gynecologicalAbdomen: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamGynecologicalAbdomenSections =
  keyof typeof GYNECOLOGICAL_ABDOMEN_FORM_INITIAL_VALUES.sections;
